import { PersistenceRegistry, ReducerRegistry } from '../base/redux';

import { SET_ONEDRIVE_AUTHORIZING, UPDATE_ONEDRIVE_TOKEN } from './actionTypes';

const STORE_NAME = 'features/onedrive';

PersistenceRegistry.register(STORE_NAME);

ReducerRegistry.register(STORE_NAME, (state = {}, action) => {
    switch (action.type) {
    case UPDATE_ONEDRIVE_TOKEN:
        return {
            ...state,
            token: action.token,
            rToken: action.rToken,
            expireDate: action.expireDate,
            authorizing: false
        };
    case SET_ONEDRIVE_AUTHORIZING:
        return {
            ...state,
            authorizing: action.authorizing
        };
    default:
        return state;
    }
});
